import { createFileRoute } from "@tanstack/react-router";
import { HubPage } from "@/components/HubPage";
import { commercialServices } from "@/data/site";

export const Route = createFileRoute("/commercial/")({
  head: () => ({
    meta: [
      { title: "Commercial Pressure Washing – Broward County | Coastal Surface Experts" },
      { name: "description", content: "Storefronts, drive-throughs, parking lots, dumpster pads, fleet washing and more across Broward County. Insured, scheduled, reliable." },
      { name: "keywords", content: "commercial pressure washing Broward, storefront cleaning Fort Lauderdale, parking lot cleaning, dumpster pad cleaning, fleet washing, drive-through cleaning, HOA cleaning, Coastal Surface Experts" },
      { property: "og:title", content: "Commercial Pressure Washing – Broward County" },
      { property: "og:description", content: "Scheduled commercial pressure washing programs across Broward." },
      { property: "og:url", content: "https://mckay.steadyautogrowthdemo.com/commercial" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/commercial" }],
  }),
  component: () => (
    <HubPage
      category="commercial"
      h1="Commercial pressure washing across Broward County."
      intro="Storefronts, restaurants, drive-throughs, parking lots, multi-family, gas stations, fleet – we run scheduled programs for property managers and operators all over Broward. $2M insured. COI on file."
      services={commercialServices}
    />
  ),
});
